import dayjs from "dayjs";

export const formatDate = (
    date: string | Date,
    format?: string,
): string => {
    return dayjs(date).format(format ?? "YYYY/MM/DD");
};

export const formatDateTime = (
    dateTime: string | Date,
    format?: string,
): string => {
    return dayjs(dateTime).format(format ?? "YYYY/MM/DD HH:mm:ss");
};

export const formatDateDDMMYYYY = (
    date: string | Date,
): string => {
    if (!date) return "N/A";

    try {
        // Handle the specific format "DD-MM-YYYY HH:mm:ss"
        if (typeof date === 'string' && date.includes('-') && date.includes(':')) {
            // Parse DD-MM-YYYY HH:mm:ss format
            const [datePart] = date.split(' ');
            const [day, month, year] = datePart.split('-');
            return `${day}-${month}-${year}`;
        }

        return dayjs(date).format("DD-MM-YYYY");
    } catch (error) {
        console.error('Error formatting date:', error);
        return "Invalid Date";
    }
};

export const getCurrentDate = (format?: string) => {
    return formatDate(
        new Date(new Date().setHours(0, 0, 0, 0)),
        format ?? "YYYY-MM-DD",
    );
};

export const formatAPIDate = (
    dateString: string | null | undefined,
): string => {
    if (!dateString) return "N/A";

    try {
        // Handle the specific API format "DD-MM-YYYY HH:mm:ss"
        if (typeof dateString === 'string' && dateString.includes('-') && dateString.includes(':')) {
            const [datePart] = dateString.split(' ');
            const [day, month, year] = datePart.split('-');
            return `${day}-${month}-${year}`;
        }

        // Fallback to dayjs for other formats
        return dayjs(dateString).format("DD-MM-YYYY");
    } catch (error) {
        console.error('Error formatting API date:', error);
        return "Invalid Date";
    }
};

export const formatLastLogin = (
    dateString: string | null | undefined,
): string => {
    if (!dateString) return "--";

    try {
        // Handle the specific API format "DD-MM-YYYY HH:mm:ss"
        if (typeof dateString === 'string' && dateString.includes('-') && dateString.includes(':')) {
            const [datePart] = dateString.split(' ');
            const [day, month, year] = datePart.split('-');

            // Create a proper date object and format it
            const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
            return dayjs(date).format("DD MMMM YYYY");
        }

        // Fallback to dayjs for other formats
        return dayjs(dateString).format("DD MMMM YYYY");
    } catch (error) {
        console.error('Error formatting last login date:', error);
        return "Invalid Date";
    }
}; 